import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import classnames from 'classnames';

import { IPost, WidgetType, IRelatedPost } from '../../lib/types';

import styles from './Widget.module.scss';
import useWebView from '../../utils/hooks/useWebView';

interface WidgetProps {
  post?: IPost;
  relatedPosts?: IRelatedPost[];
  type: WidgetType;
  classname?: string;
}

const Widget = (props: WidgetProps) => {
  const [loaded, setLoaded] = useState(false);
  const [widgets, setWidgets] = useState([]);
  const [utmMedium, setUtmMedium] = useState('side_banner');
  const isWebView = useWebView();
  const { post, relatedPosts, classname, type } = props;
  const slug = post && post.slug ? post.slug : '';
  let widgetComponent;

  const fetchWidgets = async (typeFetched: WidgetType) => {
    let widgetsFetched;
    let utmMediumFetched = 'side_banner';

    switch (typeFetched) {
      case 'ARTICLE':
        widgetsFetched = ['related-post'];
        utmMediumFetched = 'side_banner';
        break;
      case 'DESKTOP_AFTER_POST':
        widgetsFetched = ['banner-leads', 'end-banner'];
        utmMediumFetched = 'end_banner';
        break;
      case 'MOBILE_AFTER_POST':
        widgetsFetched = ['banner-leads', 'end-banner', 'related-post'];
        utmMediumFetched = 'end_banner';
        break;
      case 'HOME':
        widgetsFetched = ['search', 'related-post'];
        utmMediumFetched = 'side_banner';
        break;
    }

    setWidgets(widgetsFetched);
    setUtmMedium(utmMediumFetched);
    setLoaded(true);
  };

  useEffect(() => {
    if (!loaded) {
      fetchWidgets(type);
    }
  }, [loaded, type]);

  return (
    <div
      className={classnames(styles.widget__wrapper, {
        [styles['widget__right-sidebar']]: classname === 'right-sidebar',
        [styles['widget__after-post-sidebar']]: classname === 'after-post',
      })}
    >
      {widgets &&
        widgets.map((widget) => {
          switch (widget) {
            case 'banner-leads':
              const BannerLeads = dynamic(() => import('../Widget/BannerLeads/BannerLeads'));
              widgetComponent = !isWebView ? (
                <div className={styles.widget__item} key={widget}>
                  <BannerLeads slug={slug} utmMedium={utmMedium} categories={post.categories} />
                </div>
              ) : (
                <></>
              );
              break;
            case 'related-post':
              const RelatedPost = dynamic(() => import('../Widget/RelatedPost/RelatedPost'));
              widgetComponent = (
                <div className={styles.widget__item} key={widget}>
                  <RelatedPost relatedPosts={relatedPosts} />
                </div>
              );
              break;
            case 'search':
              const Search = dynamic(() => import('../Widget/Search/Search'));
              widgetComponent = (
                <div className={styles.widget__item} key={widget}>
                  <Search />
                </div>
              );
              break;
            case 'end-banner':
              const EndBanner = dynamic(() => import('../Widget/EndBanner/EndBanner'));
              widgetComponent = !isWebView ? (
                <div className={styles.widget__item} key={widget}>
                  <EndBanner slug={slug} categories={post.categories} endBanner={post.endBanner} />
                </div>
              ) : (
                <></>
              );
              break;
          }
          return widgetComponent;
        })}
    </div>
  );
};

export default Widget;
